
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ToggleButton from '@/ui-components/ToggleButton.vue';
import { PlotRecommenderState } from './plot-recommender.store';
import { Scoring, SCORINGS } from '@/helpers/scoring-helper';

const LpPlotRecommender = namespace('LpPlotRecommender');

@Component({
	name: 'PlotRecommenderRatingFilter',
	components: { ToggleButton },
})
export default class PlotRecommenderRatingFilter extends Vue {
	@LpPlotRecommender.State filters: PlotRecommenderState['filters'];
	@LpPlotRecommender.Mutation SET_FILTER: Function;

	get scorings(): Scoring[] {
		const scoringFilters = this.filters.scoring_filter_types;
		return SCORINGS.filter(scoring => scoring.filterDisplay).map(scoring => {
			const value =
				scoringFilters && scoringFilters[scoring.provider]
					? scoringFilters[scoring.provider].min_scoring_value
					: 0;
			return {
				...scoring,
				value: this.round(value),
			};
		});
	}

	/**
	 * the range slider has changed and needs to update the store as well.
	 */
	changed(scoring: Scoring, evt: any) {
		let value = evt.target?.value as number | undefined;
		if (value === undefined) {
			return;
		}
		value = this.round(value);
		const filterValue = {
			...this.filters.scoring_filter_types,
			[scoring.provider]: { min_scoring_value: value },
		};
		if (value === scoring.min) {
			delete (filterValue as any)[scoring.provider];
		}
		this.SET_FILTER({ key: 'scoring_filter_types', value: Object.keys(filterValue).length ? filterValue : null });
	}

	/**
	 * This functions updates the pin on the slider
	 *
	 * @param {any} event - the event that gets fired
	 * @param {string} sliderName - the name of the slider
	 *
	 */
	updatePin(event: any, sliderName: string): void {
		let sliderPin = (this.$refs as any)[`range-${sliderName}`][0].shadowRoot.querySelector('.range-pin');
		if (sliderPin) {
			sliderPin.textContent = this.round(event.detail.value);
		}
	}

	private round(rating: number) {
		return Math.round(rating * 10) / 10;
	}
}
